/**
 * The canonical breakpoint scale (piece 1). The anchors are devices: 390px is an
 * iPhone 13 in portrait, 428px larger or landscape phones, 768px a tablet in
 * portrait, 1024px a tablet in landscape or a small laptop, 1920px and wider a
 * wide desktop. `apps/web/src/styles/breakpoints.css` draws the same numbers as
 * custom media, and a test holds the two to each other.
 */
export const breakpoints = {
  xs: 390,
  sm: 428,
  md: 768,
  lg: 1024,
  xl: 1440,
  xxl: 1920,
} as const;

export type BreakpointName = keyof typeof breakpoints;

export const breakpointOrder: readonly BreakpointName[] = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];

/** Component-local thresholds the specification defines; they are not part of the app-shell scale. */
export const componentBreakpoints = {
  listViewerCompact: 480,
  eventBookingNarrow: 432,
  /** 🔒 A file row's wide layout, from this width of its own box (decision 3013). */
  fileRowWide: 460,
  /**
   * 🔒 Below this window width, with the list pane open beside it, a document's notes rail stands under its sheet
   * rather than at its right, so the sheet takes the document's whole column (T3685; decision 11540).
   */
  documentRailBeside: 1280,
} as const;
